/**
 * Resolve an image/upload URL for the current environment.
 *
 * Design rationale
 * ----------------
 * The React app is served by the same ingress that serves the API:
 *   preview:      https://floreal-como.preview.emergentagent.com
 *   production:   https://florealworld.com
 * Both route `/api/*` to the backend and everything else to the frontend.
 * Because they share the origin, we prefer RELATIVE URLs so the browser
 * resolves them against `window.location.origin` — this makes uploads work
 * automatically on any custom domain the user attaches later.
 *
 * We still fall back to REACT_APP_BACKEND_URL when necessary (e.g. running
 * `yarn start` locally on port 3000 with the backend on port 8001, where a
 * dev proxy or CORS may be involved).
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function resolveImageUrl(src) {
    if (!src) return '';
    // Already absolute → leave it (external CDN or fully-qualified upload)
    if (src.startsWith('http://') || src.startsWith('https://')) return src;

    // Path starting with `/` → use RELATIVE URL so the browser resolves it
    // against the current origin. Works in preview, prod, and any custom
    // domain (like florealworld.com) without rebuild.
    if (src.startsWith('/')) return src;

    // Anything else (bare filename): fall back to BACKEND_URL joining.
    return `${BACKEND_URL}/${src}`;
}

export default resolveImageUrl;
